import { useMapEvents } from 'react-leaflet';

const MapCenterReporter = ({ onCenterChange }) => {
  useMapEvents({
    moveend: (event) => {
      onCenterChange?.(event.target.getCenter());
    },
  });
  return null;
};

export default MapCenterReporter;
